import { Button, Card, Label, TextInput } from "flowbite-react"
import Modal from "./Modal"
import { useForm } from "react-hook-form"
import { BsEnvelope, BsLockFill, BsXCircle } from "react-icons/bs"
import { toast } from "react-toastify"
import { FaArrowRight } from "react-icons/fa6"

export const PasswordResetModal = ({ switchToLogin }) => {
    const {
        getValues,
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm()

    const resetPasswordRequest = async (data) => {
        const base_url = import.meta.env.VITE_APP_BASE_ENDPOINT;
        const reset_url = `${base_url}/dj-rest-auth/password/reset/`;
        
        console.log('Making password reset request to REST API:', reset_url);

        try {
            const response = await fetch(reset_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: data.email
                }),
            });

            if (response.ok) {
                toast.info('Password reset link sent to your email. Please check your inbox.');
                switchToLogin();
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.email?.[0] || errorData.detail || 'Failed to send password reset email';
                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error('Password reset error:', error);
            toast.error(error.message || 'An error occurred. Please try again later.');
        }
    };

    return (
        <Card size={'sm'} >
            <div className="flex flex-col gap-4 w-full ">
                <div className="flex flex-row justify-between">
                    <div className="flex flex-row">
                        <h3 className="flex flex-row gap-4 items-center justify-center text-2xl font-bold">
                            <BsLockFill /> Reset Password
                        </h3>
                    </div>

                    <Button onClick={switchToLogin} color="light" outline size={'xs'}>
                        <BsXCircle />
                    </Button>
                </div>

                <hr />
                <form onSubmit={handleSubmit(resetPasswordRequest)} className="flex flex-col gap-3">
                    <Label>Enter the email address to receive a password reset link </Label>
                    <TextInput
                        {...register('email', {
                            required: "Please enter an email to receive the password reset",
                            pattern: {
                                value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                message: 'Please enter a valid email address'
                            }
                        })}
                        color={errors.email ? 'failure' : 'gray'}
                        helperText={errors.email?.message}
                        icon={BsEnvelope}
                        type="email"
                        placeholder="Email *"
                        className='w-full'
                    />

                    <div className="flex flex-row justify-between">
                        <Button pill color='success' type="submit" className='w-fit'>
                            Send Reset Link
                        </Button>
                        <p onClick={switchToLogin} className='w-fit text-sm cursor-pointer flex flex-row items-center justify-end gap-2 text-blue-600'>
                            Back to Log In <FaArrowRight />
                        </p>
                    </div>
                </form>
            </div>
        </Card>
    )
}